module.exports = __webpack_public_path__ + "img/logo.b62ff5c5.svg";